import { Injectable } from '@angular/core';
import { StripeService } from 'ngx-stripe';
import { PaymentRequestOptions } from '@stripe/stripe-js';
import { BehaviorSubject } from 'rxjs';
import { TaxCalculatorService } from '@features/ordering/services/tax-calculator.service';
import { PaymentRequestApiType } from '@shared/enums/PaymentRequestApiType';
import { DetectBrowser, MobileDevices } from './detect-browser.services';
import { UserPaymentProvider } from '../models/payment-service-models.model';

/**
 * Payment Request service is wrapper around StripeService
 * author: rumesh
 */
@Injectable()
export class PaymentRequestService extends DetectBrowser {


  paymentRequestOption: PaymentRequestOptions;
  canMakePayment = new BehaviorSubject(PaymentRequestApiType.Other);
  paymentRequest: any;
  paymentRequestSubject = new BehaviorSubject(null);
  public userPaymentProvider: UserPaymentProvider;
  public paymentDetails: PaymentDetailsInit;

  /**
   * Default value
   * @param label
   * @param amount
   */
  setPaymentRequestOption(label: string, amount: number) {
      this.paymentRequestOption = {
        country: 'US',
        currency: 'usd',
        total: {
            label: label,
            amount: amount
        },
        requestShipping: false,
        requestPayerPhone: false,
        requestPayerEmail: false
      };
      this.setOrUpdatePaymentDetails(amount, label);
  }

  /**
  * Update the amount in the payment option
  * @param label
  * @param amount
  */
  updatePaymentRequestOption(label: string, amount: number) {
    const updateAmount: number = this.taxCalculatorService.RoundAwayFromZero(amount * 100, 0);
    if (this.paymentRequest) {
      this.paymentRequest.update({
        total: {
          amount : updateAmount,
          label : label
        }
      });
    }
    this.setOrUpdatePaymentDetails(this.taxCalculatorService.RoundAwayFromZero(amount, 2), label);
  }

  constructor(private stripeService: StripeService,
    private taxCalculatorService: TaxCalculatorService) {
    super();
    this.initializeService();
  }
  private initializeService() {
    this.setPaymentRequestOption('default', 1);
    this.paymentRequest = this.stripeService.paymentRequest(this.paymentRequestOption);
    this.paymentRequestSubject.next(this.paymentRequest);
    this.eligibleToPayViaPaymentRequest();
  }

  private setOrUpdatePaymentDetails(amount: number, label: string) {
    this.paymentDetails = {
      total: {
        amount: {
          currency: 'USD',
          value: amount?.toString(),
        },
        label: label
      }
    };
  }

  /**
    * Determine the browser and user profile eligible for apple or google
    */
  private eligibleToPayViaPaymentRequest() {
    if (this.paymentRequest !== undefined) {
      this.paymentRequest?.canMakePayment().then(result => {
        if (result) {
          console.log('canMakePayment', JSON.stringify(result));
          if (result.applePay && this.isSafari()) {
            console.log('Stripe Apple Pay');
            this.canMakePayment.next(PaymentRequestApiType.ApplePay);
          } else if (this.isChrome() && this.getDeviceLoggedIn() === MobileDevices.Andriod) {
            console.log('Stripe Google Pay');
            this.canMakePayment.next(PaymentRequestApiType.GooglePay);
          }
        }
      });
    }
  }

}
